import React from "react";

import AddEditSkills from "./AddEditSkills";
import AddEditEmployment from "./AddEditEmployment";
import AddEditLicenseCertification from "./AddEditLicenseCertification";
import BaseCard from "../../../components/ui/BaseCard";
import AddEditAboutMe from "./AddEditAboutMe";
import AddEditEducation from "./AddEditEducation";
import AddEditResume from "./AddEditResume";
import AddEditBackgroundVerification from "./AddEditBackgroundVerification";
import AddEditEquipments from "./AddEditEquipments";
import AddEditLanguage from "./AddEditLanguage";

// What used to be the settings Profile tab, shown inside Personal Info. Everyone gets
// their About Me; the caller adds `withEngineerProfile` for an engineer's professional
// profile, so this block never has to work out a role itself.
const ProfileSetting = ({
  user,
  refetchMe,
  qualificationTypeMap = {},
  withEngineerProfile = false,
}) => (
  <BaseCard className="py-2 px-4 sm:px-6 rounded-lg" elevation={1}>
    <AddEditAboutMe
      description={user?.description}
      refetchMe={refetchMe}
      // With nothing below it, About Me needs no divider under it.
      className={withEngineerProfile ? "mt-2 border-b pb-6" : "my-2"}
    />
    {withEngineerProfile && (
      <>
        <AddEditEducation userId={user?.id} />
        <AddEditResume resume={user?.resume} refetchMe={refetchMe} userId={user?.id} />
        <AddEditBackgroundVerification
          userId={user?.id}
          backgroundCheckId={qualificationTypeMap["background check"]}
        />
        <AddEditSkills userId={user?.id} />
        <AddEditEquipments userId={user?.id} equipmentId={qualificationTypeMap["equipment"]} />
        <AddEditLicenseCertification
          userId={user?.id}
          licencesId={qualificationTypeMap["licences"]}
          certificationId={qualificationTypeMap["certification"]}
        />
        <AddEditEmployment userId={user?.id} />
        <AddEditLanguage userId={user?.id} />
      </>
    )}
  </BaseCard>
);

export default ProfileSetting;
